// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme--whitegreen {
  --color-primary: 0 196 184;
  --color-on-primary: 255 255 255;
  --color-primary-hover: 177 177 178;
  --color-on-primary-hover: 36 55 70;
  --color-primary-selected: 240 240 240;
  --color-secondary: 65 160 255;
  --color-on-secondary: 255 255 255;
  --color-tertiary: 21 201 62;
  --color-on-tertiary: 250 250 250;
  --color-alert: 241 68 110;
  --color-surface-dark: 250 249 255;
  --color-surface-light: 246 244 254;
  --color-off-white: 240 240 255;
  --color-dark-text: 20 20 60;
  --color-semi-dark-text: 35 30 60;
  --color-stroke: 200 200 220;
  --color-input: 51 51 51;
  --color-menu-background: 250 250 250;
  --color-menu-shadow: 100 100 100;
  --color-menu-border: 0 196 184;
  --color-menu-selected-border: 0 196 184;
  --color-menu-text: 0 0 0;
}

.theme--black {
  --color-primary: 0 0 0;
  --color-on-primary: 255 255 255;
  --color-primary-hover: 177 177 178;
  --color-on-primary-hover: 36 55 70;
  --color-primary-selected: 110 109 115;
  --color-secondary: 65 160 255;
  --color-on-secondary: 255 255 255;
  --color-tertiary: 21 201 62;
  --color-on-tertiary: 250 250 250;
  --color-alert: 241 68 110;
  --color-surface-dark: 250 249 255;
  --color-surface-light: 246 244 254;
  --color-off-white: 240 240 255;
  --color-dark-text: 20 20 60;
  --color-semi-dark-text: 35 30 60;
  --color-stroke: 200 200 220;
  --color-input: 51 51 51;
  --color-menu-background: 0 0 0;
  --color-menu-shadow: 0 0 0;
  --color-menu-border: 0 196 184;
  --color-menu-selected-border: 255 255 255;
  --color-menu-text: 255 255 255;
}

.theme--darkbluegray {
  --color-primary: 36 55 70;
  --color-on-primary: 255 255 255;
  --color-primary-hover: 177 177 178;
  --color-on-primary-hover: 36 55 70;
  --color-primary-selected: 110 109 115;
  --color-secondary: 65 160 255;
  --color-on-secondary: 255 255 255;
  --color-tertiary: 21 201 62;
  --color-on-tertiary: 250 250 250;
  --color-alert: 241 68 110;
  --color-surface-dark: 250 249 255;
  --color-surface-light: 246 244 254;
  --color-off-white: 240 240 255;
  --color-dark-text: 20 20 60;
  --color-semi-dark-text: 35 30 60;
  --color-stroke: 200 200 220;
  --color-input: 51 51 51;
  --color-menu-background: 36 55 70;
  --color-menu-shadow: 36 55 70;
  --color-menu-border: 0 196 184;
  --color-menu-selected-border: 255 255 255;
  --color-menu-text: 255 255 255;
}

.theme--darkblue {
  --color-primary: 6 29 96;
  --color-on-primary: 255 255 255;
  --color-primary-hover: 177 177 178;
  --color-on-primary-hover: 6 29 96;
  --color-primary-selected: 110 109 115;
  --color-secondary: 65 160 255;
  --color-on-secondary: 255 255 255;
  --color-tertiary: 21 201 62;
  --color-on-tertiary: 250 250 250;
  --color-alert: 241 68 110;
  --color-surface-dark: 250 249 255;
  --color-surface-light: 246 244 254;
  --color-off-white: 240 240 255;
  --color-dark-text: 20 20 60;
  --color-semi-dark-text: 35 30 60;
  --color-stroke: 200 200 220;
  --color-input: 51 51 51;
  --color-menu-background: 6 29 96;
  --color-menu-shadow: 6 29 96;
  --color-menu-border: 6 29 96;
  --color-menu-selected-border: 255 255 255;
  --color-menu-text: 255 255 255;
}

.theme--steelblue {
  --color-primary: 84 151 194;
  --color-on-primary: 255 255 255;
  --color-primary-hover: 107 174 214;
  --color-on-primary-hover: 255 255 255;
  --color-primary-selected: 65 120 164;
  --color-secondary: 164 194 224;
  --color-on-secondary: 0 0 0;
  --color-tertiary: 130 177 217;
  --color-on-tertiary: 255 255 255;
  --color-alert: 255 0 0;
  --color-surface-dark: 245 245 255;
  --color-surface-light: 250 250 255;
  --color-off-white: 240 245 255;
  --color-dark-text: 25 30 70;
  --color-semi-dark-text: 40 45 80;
  --color-stroke: 210 215 230;
  --color-input: 51 51 51;
  --color-menu-background: 84 151 194;
  --color-menu-shadow: 84 151 194;
  --color-menu-border: 0 196 184;
  --color-menu-selected-border: 255 255 255;
  --color-menu-text: 255 255 255;
}

.theme--orange {
  --color-primary: 230 155 86;
  --color-on-primary: 255 255 255;
  --color-primary-hover: 240 167 107;
  --color-on-primary-hover: 255 255 255;
  --color-primary-selected: 208 132 74;
  --color-secondary: 242 193 139;
  --color-on-secondary: 0 0 0;
  --color-tertiary: 230 160 124;
  --color-on-tertiary: 255 255 255;
  --color-alert: 255 0 0;
  --color-surface-dark: 255 250 240;
  --color-surface-light: 255 245 235;
  --color-off-white: 240 245 255;
  --color-dark-text: 50 30 20;
  --color-semi-dark-text: 70 50 40;
  --color-stroke: 230 220 210;
  --color-input: 51 51 51;
  --color-menu-background: 230 155 86;
  --color-menu-shadow: 230 155 86;
  --color-menu-border: 0 196 184;
  --color-menu-selected-border: 255 255 255;
  --color-menu-text: 255 255 255;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
